'use strict';

exports.MatrixStatsAggregation = require('./matrix-stats-aggregation');
